import React from 'react';
import PropTypes from 'prop-types';
import { Cross } from '@bufferapp/ui/Icon';
import { StyledWrapper, CloseButton } from './styles';

const ComposerSidepanel = ({
  isVisible,
  showCloseButton,
  closeButtonPosition,
  customStyles,
  onClose,
  children,
}) => {
  return (
    <StyledWrapper
      data-testid="composer-sidepanel"
      $isVisible={isVisible}
      $customStyles={customStyles}
    >
      {showCloseButton && (
        <CloseButton position={closeButtonPosition}>
          <Cross size="medium" onClick={onClose} data-testid="close-button" />
        </CloseButton>
      )}
      {children}
    </StyledWrapper>
  );
};

ComposerSidepanel.propTypes = {
  isVisible: PropTypes.bool,
  // Pass any additional style properties you want applied
  customStyles: PropTypes.shape({}),
  showCloseButton: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node.isRequired,
  closeButtonPosition: PropTypes.shape({
    top: PropTypes.string,
    right: PropTypes.string,
  }),
};

ComposerSidepanel.defaultProps = {
  isVisible: false,
  customStyles: {},
  showCloseButton: false,
  closeButtonPosition: null,
  onClose: () => {},
};

export default ComposerSidepanel;
